/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Rule3_ActionInputs */

const tr_landing_pricerules_mock_rule3_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule3_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seçili markada kur oranında zam`)
};

const en_landing_pricerules_mock_rule3_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule3_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected brand rises with the rate`)
};

const de_landing_pricerules_mock_rule3_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule3_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewählte Marke steigt mit dem Kurs`)
};

const ru_landing_pricerules_mock_rule3_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule3_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбранный бренд дорожает по курсу`)
};

/**
* | output |
* | --- |
* | "Selected brand rises with the rate" |
*
* @param {Landing_Pricerules_Mock_Rule3_ActionInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_rule3_action = /** @type {((inputs?: Landing_Pricerules_Mock_Rule3_ActionInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Rule3_ActionInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_rule3_action(inputs)
	if (locale === "de") return de_landing_pricerules_mock_rule3_action(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_rule3_action(inputs)
	return tr_landing_pricerules_mock_rule3_action(inputs)
});